import { ContentfulCardLegacy } from '@reward-platform/contentful'
import { SearchTabQuery } from '~/schemas/searchPageParams'
import { InteractivePod } from '../Pod/InteractivePod'
import style from './InteractivePodsGrid.module.scss'

type Props = {
  cards: ContentfulCardLegacy[]
  product: SearchTabQuery
}

export function InteractivePodsGrid({ cards, product }: Props) {
  return (
    <div className={style.wrapper}>
      {cards.map((card) => (
        <InteractivePod
          key={card.destinationAirport ?? card.heading ?? card.subHeading ?? card.caption}
          card={card}
          product={product}
        />
      ))}
    </div>
  )
}
